/**
 * Environment flags (Create React App).
 * Values come from `.env`, `.env.development`, `.env.production`, and optional `.env*.local` (gitignored).
 *
 * - `npm start` → development (loads `.env.development`)
 * - `npm run build` → production (loads `.env.production`)
 */

/** Explicit app tier: local | development | production (set in env files). */
export const REACT_APP_ENV = process.env.REACT_APP_ENV ?? process.env.NODE_ENV ?? 'development';

export const isDevelopment = process.env.NODE_ENV === 'development';

function ensureApiSuffix(url: string): string {
  const trimmed = url.replace(/\/+$/, '');
  if (!trimmed) return trimmed;
  if (/\/api$/i.test(trimmed)) return trimmed;
  return `${trimmed}/api`;
}

/** Backend API root from `REACT_APP_API_BASE_URL` in env; must end with `/api`. */
export const REACT_APP_API_BASE_URL = ensureApiSuffix(
  (process.env.REACT_APP_API_BASE_URL ?? '').trim()
) || '/api';

/**
 * Master admin analytics / AI-admin routes (e.g. `.../api/admin`).
 * Set in `.env.development` / `.env.production` when it differs from `{REACT_APP_API_BASE_URL}/admin`.
 */
export const REACT_APP_ADMIN_API_BASE_URL = process.env.REACT_APP_ADMIN_API_BASE_URL ?? '';

export const REACT_APP_GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '';
